module.exports = __webpack_public_path__ + "img/authority.8b491148.png";